export default __webpack_public_path__ + "static/media/reports_selected.9a8678ac.svg";